import { render as renderProductInformationHeader } from './components/product-information-header'
import template from '../common/template'

const productInformationHeader = (basicPlan, selectedPlanName, selectedPlanCode, redLine) =>
  renderProductInformationHeader(basicPlan, selectedPlanName, selectedPlanCode, redLine)

const healthTemplate = async (props) => {
  const { basicPlan, selectedPlanName, selectedPlanCode, redLine } = props
  const header = productInformationHeader(basicPlan, selectedPlanName, selectedPlanCode, redLine)
  return template(props, header)
}

export default healthTemplate
